<template>
  <div class="modal-overlay" @click.self="close()">
    <div class="modal-content">
      <!-- 標題 -->
      <div class="title gept_main_bg text-white py-3 position-relative font-weight-semibold h5 mb-0">
        AI批改
        <a
          class="close-btn position-absolute"
          style="top:0; right:0;"
          @click="close()"
        >
          <i class="fas fa-times"></i>
        </a>
      </div>

      <div class="p-4">
        <div class="contain scroll-bar" v-if="selectItemIdx > -1">

          <!-- 已有資料 -->
          <div class="report-modal-body d-flex mb-3" v-if="itemData?.result && isReadyShow">
            <!-- Score -->
            <div class="report-modal-score col-2 pr-2" v-if="type !== 'speaking' && itemData.result && itemData.result.ers && itemData.result.ers.Score">
              <div class="report-modal-score-card bg-white w-100 h-100 d-flex align-items-center justify-content-center">
                <div class="report-modal-score-content font-weight-bold text-center">
                  <p class="report-modal-score-label mb-2">Score</p>
                  <p class="report-modal-score-value display-4 font-semibold" v-if="itemData.result.ers">
                    {{ itemData.result.ers.Score }}
                  </p>
                </div>
              </div>
            </div>

            <!-- 內容 -->
            <div class="report-modal-main flex-1">
              <!-- Question -->
              <div class="d-flex rounded-lg overflow-hidden mb-1">
                <div class="p-4 gept_main_bg6 text-white d-flex align-items-center">
                  Q{{ selectChildIdx + 1 }}
                </div>
                <div class="flex-1 bg-white d-flex align-items-center p-1">
                  <div
                    class="p-2 pointer"
                    v-if="itemData.result.question && itemData.result.question.AudioUrl"
                    @click.prevent="setAudio(itemData.result.question.AudioUrl)"
                  >
                    <img
                      class="d-block mx-auto img-fluid object-contain"
                      style="width:80%;"
                      src="@/assets/image/gept/m_play.png"
                      alt=""
                    >
                  </div>

                  <div>
                    <div v-if="itemData.result.question && itemData.result.question.ImageUrl">
                      <img :src="itemData.result.question.ImageUrl" alt="" class="object-contain w-100">
                    </div>

                    <p
                      v-if="itemData.result.question && itemData.result.question.Title"
                      class="h5 font-semibold mb-0 text-left"
                      v-html="itemData.result.question.Title.replace(/(?:\r\n|\r|\n)/g, '<br/>')"
                    ></p>
                  </div>
                </div>
              </div>

              <!-- Answer -->
              <div class="teacher_answer rounded-lg mb-1 d-flex overflow-hidden">
                <div class="p-4 gept_main_bg5 text-white d-flex align-items-center">
                  A{{ selectChildIdx + 1 }}
                </div>
                <div class="flex-1 bg-white p-1 d-flex align-items-center">
                  <div class="d-flex align-items-center mb-2">
                    <div
                      class="p-2 pointer"
                      v-if="itemData.user_answer && itemData.user_answer.audio"
                      @click.prevent="setAudio(itemData.user_answer.audio)"
                    >
                      <img
                        class="d-block mx-auto img-fluid object-contain"
                        style="width:80%;"
                        src="@/assets/image/gept/voice_play.png"
                        alt=""
                      >
                    </div>

                    <p
                      class="h5 font-weight-semibold mb-0 text-left"
                      v-if="hasScoredAnswerText"
                    >
                      <span
                        v-for="(child, idx) in spiltWords(scoredAnswerText)"
                        :key="idx"
                        :class="{
                          'good-text': checkScore(answerWordScores, scoredAnswerText, child) > 80,
                          'acceptable-text': checkScore(answerWordScores, scoredAnswerText, child) > 60
                            && checkScore(answerWordScores, scoredAnswerText, child) < 81,
                          'strengthened-text': checkScore(answerWordScores, scoredAnswerText, child) < 61
                        }"
                      >
                        {{ child }}
                      </span>
                    </p>

                    <p
                      class="h5 font-weight-semibold mb-0 text-left"
                      v-else-if="answerText"
                      v-html="return_user_text(answerText)"
                    ></p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Loading -->
          <div v-else>
            <div class="d-flex justify-content-center w-100">
              <LottieAnimation
                class="w-25 w-xl-15"
                ref="anim"
                :animationData="require('@/assets/image/gept/mark_loading.json')"
                :loop="true"
                :auto-play="true"
                :speed="1"
              />
            </div>

            <div class="d-flex justify-content-center w-100">
              <div class="w-75 bg-white mt-4 rounded-pill position-relative overflow-hidden" style="height:8px;">
                <div class="position-absolute h-100 gept_main_bg progress"></div>
              </div>
            </div>

            <p class="text-center mt-4 gept_main_color font-weight-bold h5">
              正在批改...
            </p>
          </div>

          <!-- AI 結果 -->
          <div
            class="bg-white p-2 px-3" v-if="resultText && isReadyShow && !newResult">
            <p class="mb-3 h5 text-left" v-if="!newResult"
              v-html="return_user_text(resultText)"
            ></p>
            <div v-else>
              <div>
                <div class="text-lg font-bold text-center p-1 text-white bg-secondary">總分</div>
                <div class="d-flex align-items-center justify-content-center p-3 lg:p-6 lg:py-4 md:py-12">
                  <div class="d-flex align-items-end">
                    <div class="text-5xl font-semibold">{{ getTotalScore }}</div>
                    <div class="text-sm text-gray-500 ml-1">/ {{ newResult?.maxScore }} 分</div>
                  </div>
                </div>
              </div>
              <div>
                <div class="text-lg font-bold text-center p-1 text-white bg-secondary">綜合建議</div>
                <div class="p-3 lg:p-6 lg:py-4 text-lg text-left">
                  <p class="mb-6">{{ newResult?.summarize }}</p>

                  <p v-if="newResult?.articleInfo" class="font-bold d-flex mb-1"><img src="@/assets/image/emoji/emoj_136.png" alt="" class="mr-1 mb-1">段落架構：</p>
                  <p v-if="newResult?.articleInfo">{{ newResult?.articleInfo }}</p>
                </div>
              </div>
              <div>
                <div class="text-lg font-bold text-center p-1 text-white bg-secondary">架構分析</div>
                <div class="p-3 lg:p-6 lg:py-4 text-lg text-left">
                  <p class="font-bold d-flex mb-6">{{ newResult.relevance }}</p>
                  <div class="mb-6" v-if="newResult.content">
                    <p class="font-bold d-flex flex-wrap mb-2 align-items-center"><img src="@/assets/image/emoji/emoj_631.png" alt="" class="mr-1">內容 Content：
                      <star-rating
                        v-if="newResult && newResult.maxScore > 4"
                        :max-rating="5"
                        border-color="#000000"
                        active-color="#FFC83D"
                        inactive-color="#7C6755"
                        :rating="getStarRating(newResult.content.viewscore)"
                        :read-only="true"
                        :increment="0.5"
                        :star-size="30"
                        :rounded-corners="true"
                        :border-width="4"
                        :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                        :show-rating="false"
                      />
                      <span>{{ newResult.content.viewscore }}分</span>
                    </p>
                    <p class="ai_text_10">{{ newResult.content?.emoji }} {{ newResult.content?.feedback }}</p>
                  </div>
                  <div class="mb-6" v-if="newResult.organization">
                    <p class="font-bold d-flex flex-wrap mb-2 align-items-center"><img src="@/assets/image/emoji/emoj_631.png" alt="" class="mr-1">組織 Organization：
                    <star-rating
                      v-if="newResult && newResult.maxScore > 4"
                      :max-rating="5"
                      border-color="#000000"
                      active-color="#FFC83D"
                      inactive-color="#7C6755"
                      :rating="getStarRating(newResult.organization.viewscore)"
                      :read-only="true"
                      :increment="0.5"
                      :star-size="30"
                      :rounded-corners="true"
                      :border-width="4"
                      :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                      :show-rating="false"
                      />

                    </p>
                    <p class="ai_text_10">{{ newResult.organization?.emoji }} {{ newResult.organization?.feedback }}</p>
                  </div>
                  <div class="mb-6" v-if="newResult.grammar">
                    <p class="font-bold d-flex flex-wrap mb-2 align-items-center"><img src="@/assets/image/emoji/emoj_631.png" alt="" class="mr-1">文法與句構 Grammar & Sentence Structure：
                    <star-rating
                      v-if="newResult && newResult.maxScore > 4"
                      :max-rating="5"
                      border-color="#000000"
                      active-color="#FFC83D"
                      inactive-color="#7C6755"
                      :rating="getStarRating(newResult.grammar.viewscore)"
                      :read-only="true"
                      :increment="0.5"
                      :star-size="30"
                      :rounded-corners="true"
                      :border-width="4"
                      :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                      :show-rating="false"
                    />

                      <span>{{ newResult.grammar.viewscore }}分</span>
                    </p>
                    <p class="ai_text_10">{{ newResult.grammar?.emoji }} {{ newResult.grammar?.feedback }}</p>
                  </div>
                  <div class="mb-6" v-if="newResult.spelling">
                    <p class="font-bold d-flex flex-wrap mb-2 align-items-center"><img src="@/assets/image/emoji/emoj_631.png" alt="" class="mr-1">字彙與拼字 Vocabulary & Spelling：
                    <star-rating
                      v-if="newResult && newResult.maxScore > 4 && newResult.spelling"
                      :max-rating="5"
                      border-color="#000000"
                      active-color="#FFC83D"
                      inactive-color="#7C6755"
                      :rating="getStarRating(newResult.spelling.viewscore)"
                      :read-only="true"
                      :increment="0.5"
                      :star-size="30"
                      :rounded-corners="true"
                      :border-width="4"
                      :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                      :show-rating="false"
                    />

                      <span>{{ newResult.spelling.viewscore }}分</span>
                    </p>
                    <p class="ai_text_10">{{ newResult.spelling?.emoji }} {{ newResult.spelling?.feedback }}</p>
                  </div>
                </div>
              </div>
              <div>
                <div class="text-lg font-bold text-center p-1 text-white bg-secondary">文法與拼字建議</div>
                <div class="p-3 lg:p-6 lg:py-4 text-lg text-left">
                  <div v-if="newResult?.sentences?.length > 0">
                    <div v-for="(item, index) in newResult.sentences" :key="index" class="p-2 mb-2 ai_border_06" :class="{ 'border-b': index !== newResult.sentences.length - 1, 'border-0': index === newResult.sentences.length - 1 }">
                      <p class="font-bold d-flex mb-1"><img src="@/assets/image/emoji/emoj_122.png" alt="" class="mr-1">原句：</p>
                      <p class="ai_text_10 mb-1">{{ item.sentence }}</p>
                      <p class="font-bold d-flex mb-1"><img src="@/assets/image/emoji/emoj_132.png" alt="" class="mr-1">修改建議：</p>
                      <p class="ai_text_10 mb-1">{{ item.advice }}</p>
                      <p class="font-bold d-flex mb-1"><img src="@/assets/image/emoji/emoj_631.png" alt="" class="mr-1">修正後句子：</p>
                      <p class="ai_text_10">{{ item.rewriteSentence }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-white p-2 px-3" v-if="newResult?.result && isReadyShow">
            <div v-html="newResult.result.replace(/(?:\r\n|\r|\n)/g, '<br/>')" class="text-left"></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import LottieAnimation from 'lottie-web-vue'
import StarRating from 'vue-star-rating'
export default {
  name: 'ReportModal',

  data () {
    return {
      isReadyShow: false,

      sound_effect: null,
      chatRecords: null
    }
  },

  props: {
    type: {
      type: String
    },

    itemName: {
      type: String
    },

    selectItemIdx: {
      type: Number
    },

    selectChildIdx: {
      type: Number
    },

    showfirstModal: {
      type: Boolean,
      default: false
    },

    itemData: {
      type: Object
    }
  },

  components: {
    LottieAnimation,
    StarRating
  },
  computed: {
    answerText () {
      if (this.type === 'speaking') {
        return this.scoredAnswerText
      }

      return this.scoredAnswerText ||
        this.itemData?.result?.result?.text ||
        this.itemData?.result?.result?.Text ||
        this.itemData?.result?.result?.stt ||
        this.itemData?.result?.result?.sText ||
        this.itemData?.result?.text ||
        this.itemData?.result?.Text ||
        this.itemData?.result?.user_text ||
        this.itemData?.user_answer?.text ||
        ''
    },
    scoredAnswerText () {
      return this.itemData?.result?.ers?.Text || ''
    },
    answerWordScores () {
      return this.itemData?.result?.ers?.WordScores || []
    },
    hasScoredAnswerText () {
      return Boolean(this.scoredAnswerText && this.answerWordScores.length)
    },
    resultText () {
      const result = this.itemData?.result?.result
      if (typeof result === 'string') return result
      if (result && typeof result.result === 'string') return result.result
      return ''
    },
    newResult () {
      const str = this.resultText

      if (typeof str !== 'string') return null

      try {
        return JSON.parse(str)
      } catch (e) {
        return null
      }
    },
    getTotalScore () {
      const max = this.newResult && this.newResult.maxScore

      const content_score =
        this.newResult &&
        this.newResult.content &&
        this.newResult.content.viewscore
          ? this.newResult.content.viewscore
          : 0

      const organization_score =
        this.newResult &&
        this.newResult.organization &&
        this.newResult.organization.viewscore
          ? this.newResult.organization.viewscore
          : 0

      const grammar_score =
        this.newResult &&
        this.newResult.grammar &&
        this.newResult.grammar.viewscore
          ? this.newResult.grammar.viewscore
          : 0

      const spelling_score =
        this.newResult &&
        this.newResult.spelling &&
        this.newResult.spelling.viewscore
          ? this.newResult.spelling.viewscore
          : 0

      const total =
        Number(content_score) +
        Number(organization_score) +
        Number(grammar_score) +
        Number(spelling_score)

      if (max === 100 || max === 40) {
        // 取到小數第一位
        return Math.round((total / 4) * 10) / 10
      } else {
        return total
      }
    }
  },
  mounted () {
    this.setTimeoutFun()
    // this.getItemRecords(this.route.params.select_id, this.route.params.id)
  },
  methods: {
    getItemRecords (id, item_id) {
      const path = `/books/${id}/items/${item_id}`

      return api
        .get(path)
        .then(res => res.data)
        .catch(() => {
          this.$router.push({ name: 'myList' })
        })
    },
    cleanTimeOut () {
      let self = this
      clearTimeout(self.timeOutProcessId)
    },
    setTimeoutFun () {
      let self = this
      self.timeOutProcessId = setTimeout(() => {
        self.isReadyShow = true
      }, 1000 * 1)
    },

    close () {
      let self = this
      self.$emit('closeModal', false)
      // self.correctionResult = null
    },

    spiltWords (text) {
      let words = text.split(/(\s+|[,.!?])/).filter(Boolean)
      return words
    },

    checkScore (WordScores, text, child) {
      let parts = text.split(/(\s+|[,.!?])/).filter(Boolean);

      let wordsOnly = parts.filter(part => !part.match(/(\s+|[,.!?])/));

      let index = wordsOnly.indexOf(child)

      return Number(WordScores[index])
    },

    setAudio (url) {
      let self = this
      if (url) {
        if (self.sound_effect) {
          const myName1 = () => {
            return new Promise(async(resolve) => {
              self.audio_stop()
              resolve('ok')
            })
          }

          Promise.race([myName1()])
          .then(() => {
            self.sound_effect = new Audio(url)

            self.audio_play()
          })
        } else {
          self.sound_effect = new Audio(url)

          self.audio_play()
        }
      }
    },

    audio_play () {
      let self = this

      self.sound_effect ? self.sound_effect.play() : null

      self.sound_effect.addEventListener('ended', () => {
        self.audio_stop()
      })
    },

    audio_stop () {
      let self = this

      self.sound_effect.pause()
      self.sound_effect.currentTime = 0
    },

    return_user_text (text) {
      return text.replace(/(?:\r\n|\r|\n)/g, '<br/>')
    },

    getStarRating (score) {
      const maxScore = Number(this.newResult?.value?.maxScore)
      const newScore = Number(score)

      // if (typeof score !== 'number' || typeof max !== 'number') return 0

      if (maxScore === 100) {
        if (newScore >= 90) return 5
        if (newScore >= 80) return 4
        if (newScore >= 60) return 3
        if (newScore >= 40) return 2
        if (newScore >= 1) return 1
        return 0
      }

      // 40分制
      if (maxScore === 40) {
        if (newScore >= 35) return 5
        if (newScore >= 28) return 4
        if (newScore >= 21) return 3
        if (newScore >= 15) return 2
        if (newScore >= 8) return 1
        return 0
      }

      // 20分制（單項 4 分）
      if (maxScore === 4) {
        if (newScore >= 3.5) return 4
        if (newScore >= 3) return 3
        if (newScore >= 2) return 2
        if (newScore >= 1) return 1
        return 0
      }
      return newScore
    }
  }
}
</script>

<style lang="scss">
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-content {
  background-color: #E3ECF1;
  border-radius: 5px;
  width: 100%;
  min-width: 70vw;
  height: 90vh;
  max-height: 90vh;
  max-width: 70vw;
  overflow-y: scroll;
  overflow-x: hidden;
}

.report-modal-body {
  align-items: stretch;
}

.report-modal-score {
  flex: 0 0 120px;
  max-width: 120px;
  width: 120px;
}

.report-modal-score-card {
  padding: 0.75rem 0.5rem;
}

.report-modal-score-content {
  min-width: 0;
  width: 100%;
}

.report-modal-score-value {
  display: block;
  max-width: 100%;
  line-height: 1;
  margin-bottom: 0;
  white-space: nowrap;
  font-size: clamp(2rem, 4vw, 3.5rem);
  letter-spacing: 0;
}

@media (max-width: 768px) {
  .report-modal-body {
    flex-direction: column;
  }

  .report-modal-score {
    flex: 0 0 auto;
    max-width: 100%;
    width: 100%;
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-bottom: 0.5rem;
  }

  .report-modal-score-card {
    padding: 0.75rem 1rem;
  }

  .report-modal-score-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    text-align: left !important;
  }

  .report-modal-score-label {
    margin-bottom: 0 !important;
  }

  .modal-content .report-modal-score .report-modal-score-value {
    font-size: 2rem;
    line-height: 1;
    margin-bottom: 0;
  }

  .report-modal-main {
    width: 100%;
  }
}

.close-btn {
  margin-top: 8px;
  padding: 5px 10px;
  background-color: transparent;
  color: white;
  cursor: pointer;
}

  .good-bg {
    background-color: rgba(0, 149, 86, 1);
  }
  .acceptable-bg {
    background-color: rgba(255, 193, 7, 1);
  }
  .strengthened-bg {
    background-color: rgba(243, 0, 0, 1);
  }
  .good-text {
    color: rgba(0, 149, 86, 1);
  }
  .acceptable-text {
    color: rgba(255, 193, 7, 1);
  }
  .strengthened-text {
    color: rgba(243, 0, 0, 1);
  }
  .vm-btn-close {
    outline: none !important;
  }
  .modal-outer {
    max-width: 80vw;
    // max-width: 1500px;
    .vm-titlebar {
      color: white !important;
      background: #0F455C;
      text-align: center;
    }
    .vm-content {
      background: #E3ECF1;
      height: 80vh;
      overflow-x: hidden;
      overflow-y: scroll;
    }
    .teacher_answer {
      display: none;
    }
  }
  .progress {
    // background-color: #e4c465;
    animation: progressBar 3s ease-in-out infinite;
    animation-fill-mode: both;
}
  @keyframes progressBar {
    0% { width: 0; }
    100% { width: 100%; }
  }
</style>
